import { SvgIcon, SvgIconProps } from "@mui/material";

interface IIconLowBetaProps extends SvgIconProps {
    hideBorder?: boolean;
}

export const IconLowBeta = ({ hideBorder, ...props }: IIconLowBetaProps) => (
    // hideBorder also crops the side whitespace: horizontal-only crop keeps the 24-unit height so the glyph scale is unchanged
    <SvgIcon {...props} viewBox={hideBorder ? "8.9 0 7 24" : "0 0 24 24"}>
        {!hideBorder && <rect x="0.3" y="0.3" width="23.4" height="23.4" rx="11.7" stroke="#179C5F" strokeWidth="0.6" fill="none" />}
        <g clipPath="url(#clip0_low_beta)">
            <path
                d="M13.7455 10.0639C14.4505 9.8172 14.9564 9.14607 14.9564 8.35723C14.9564 7.85314 14.7501 7.3972 14.4178 7.06966C13.8519 6.51147 13.075 6.16669 12.2172 6.16669C10.4862 6.16669 9.0833 7.57018 9.0833 9.30063V17.8334H10.9124V14.6691C11.2958 15.2528 11.9556 15.6386 12.7064 15.6386C14.2995 15.6386 15.5907 14.3475 15.5907 12.7544C15.5907 11.528 14.825 10.4812 13.7461 10.0639H13.7455ZM12.1114 14.2809C11.5574 14.2809 11.0871 13.9266 10.9118 13.4332V8.85657C10.9118 8.19554 11.4474 7.65994 12.1084 7.65994C12.7694 7.65994 13.305 8.19554 13.305 8.85657C13.305 9.36839 12.8901 9.78332 12.3783 9.78332H11.7892V10.99005H12.112C13.0209 10.99005 13.7574 11.7266 13.7574 12.6355C13.7574 13.5444 13.0209 14.2809 12.112 14.2809H12.1114Z"
                fill="#179C5F"
            />
        </g>
        <defs>
            <clipPath id="clip0_low_beta">
                <rect width="14" height="14" fill="white" transform="translate(5 5)" />
            </clipPath>
        </defs>
    </SvgIcon>
);
